import { normalizeBaseUrl } from "shared-utils";
import { Api as EmailSettingsApi } from "../generated/EmailSettingsApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const emailSettingsApi = new EmailSettingsApi({
  baseURL: normalizeBaseUrl(config.emailSettingsApiUrl),
});

createAxiosRequestInterceptors(emailSettingsApi.instance);

export default emailSettingsApi;
